module.exports = __webpack_public_path__ + "assets/img/firstTimeBg.fcf62781.png";